import { createBrowserRouter } from 'react-router-dom';

import { Home } from '../views/home/home';
import { Products } from '../views/products/products';
import { Contact } from '../views/contact/contact';
import { About } from '../views/about/about';
import { Page } from '../components/page/page';

const router = createBrowserRouter([
    {
        path: '/',
        element: <Page path={'/'} Main={Home} />,
    },
    {
        path: '/products',
        element: <Page path={'/products'} Main={Products} />,
    },
    {
        path: '/contact',
        element: <Page path={'/contact'} Main={Contact} />,
    },
    {
        path: '/about',
        element: <Page path={'/about'} Main={About} />,
    },
    {
        path: '*',
        element: <Page path={'/'} Main={Home} />,
    },
]);

export default router;
